import moment from 'moment';
export default (data, colIndex, order) => { 
    return data.sort((a, b) => { 
        const columnsDate = [
                                2, /*DT_ENTRG */
                                5, /*DT_EMIS */
                                6, /*DT_PREV_ENTRG */
                                22 /*DT_SOLIC_ANTEC */
                            ]
        
        //Date
        if (!!columnsDate.find(element => element === colIndex)) {
            let va = "";
            let vb = "";
            if (a.data[colIndex] !== "")
                va = new Date(moment(a.data[colIndex]+' 12:00:00',"DD/MM/YYYY hh:mm:ss"));
            if (b.data[colIndex] !== "")
                vb = new Date(moment(b.data[colIndex]+' 12:00:00',"DD/MM/YYYY hh:mm:ss"));
            return ((va < vb) || (va === "") ? -1: 1 ) * (order === 'desc' ? 1 : -1); 
        }
        //String ou Outros
        else { 
            return (a.data[colIndex] < b.data[colIndex] ? -1: 1 ) * (order === 'desc' ? 1 : -1); 
        }
    }); 
};